import React, { Component } from "react";
import axios from "axios";

import {
  VideoCount,
  GridContainer,
  PaginationContainer,
} from "../MyVideo.style";
import Card from "../../Common/Card/Card";
import { MyVideoCardFooter } from "@/UserPage/Common/MyVideoCardFooter/MyVideoCardFooter";
import ThumbnailChangeDialog from "../../MyGallery/ChangeThubnail";
import VideoDialog from "../../Common/VideoDialog/VideoDialog";
import ConfirmationDialog from "../../Common/ConfirmationDialog/ConfirmationDialog";
import { Pagination2 } from "../../Common/Pagination2/Pagination2";
import { EmptyLayerIcon } from "../../Common/SvgIcon/EmptyLayerIcon";
import { FinishedLayerIcon } from "../../Common/SvgIcon/FinishedLayerIcon";
import { GetBaseUrl, GetOriginalBaseUrl } from '@/utils/ConfigHelper'
import GIFCropDialog from "@/UserPage/Common/GIFCropDialog/GIFCropDialog";
import Loading from '@/Common/loading/loading'
import EmptyVideo from "../emptyVideo/emptyVideo";
import UploadCompleted from '@/Common/UploadCompleted/UploadCompleted'
import OneBtnDialog from "@/Common/OneBtnDialog/OneBtnDialog";
import i18n from '@/i18n';
import ChangeTitleInput from '../ChangeTitleInput/ChangeTitleInput';
import ShareDialog from "../ShareDialog/ShareDialog";
import CopyToClipboard from 'copy-to-clipboard'
import TwoBtnDialog from "@/Common/TwoBtnDialog/TwoBtnDialog";
import Uploading from '@/Common/Uploading/Uploading'
import { ErrorHandler } from '@/utils/Error/Handler';
import { PaymentsApis, VideosApis } from '@/utils/Videomonster/Apis';
import { VideoApis } from '@/utils/Videomonster/Api';
import TemplateHelper from '@/utils/TemplateHelper'
import { USER_SOURCE_UPLOAD_POLICY, RENDER_STATE, POINT_UI_EXPIRED_DATE, ROUTE_PATH } from "@/utils/Global";
import DataManager from "@/utils/DataManager";
import OtherRatioDialog from "../OtherRatioDialog/OtherRatioDialog";

import { Logout, FetchCoupons } from '@/Interface'

import { connect } from 'react-redux'
import { REDUX_ACTION } from '@/Redux/action'
import { ReduxBinding } from '@/Redux/instance'

import { Trans } from 'react-i18next'
import JSzip from "jszip";
import JszipUtils from "jszip-utils"
import { PUBLIC_ERROR_CODE } from "@/utils/Error/Constants";
import Validator from "@/utils/Validator";
import TokenHelper from "@/utils/DataManager/TokenHelper";
import { getIsExpiredDate } from "@/utils/DateHelper";
import VideoInfoDialog from "@/Common/VideoInfoDialog/VideoInfoDialog";

const formatDate = videoDate => {
  const date = new Date(videoDate);
  const dateString = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .split("T")[0];
  const finalDate = dateString.replace(/-/g, ".");
  return finalDate;
};

class TemplatePage extends Component {

  _isMounted = false

  state = {
    isDialogOpened: false,
    focusedDialogName: "",
    isBtnDialogOpened: false,
    dialogType: "failEditVideo",
    selectedVideoId: null,
    currentPage: 0,
    cardsPerPage: 15,
    myVideos: undefined,
    isNoPayment: true,
    userRemoveTemplate: false,

    renderingVideos: {},
    isOpenSettingDropdown: false,
    isChangeTitleInputDialog: false,
    videoId: "",
    title: "",
    isShareDialogOpen: false,
    selectedVideo: {},
    isOpenWaterMarkTwoButton: false,
    isOpenOtherRatioDialog: false,
    isOpenPayTwoButton: false,
    isOpenUseCouponTwoButton: false,

    selectedThumbnail: '',

    previews: [],
    
    isUploading: false,
    isVideoInfoDialogOepn:false,
    videoInfo:{
      name:"",
      videoName:"",
      fonts:[],
      music:[],
    },
    GifCropDialogProps: {
      open: false,
      src: null,
      vidoeId: null
    },
    totalVideos: 0
  };
  provider = DataManager.GetProvider()

  getMyvideo = async () => {
    const token = localStorage.getItem('token');
    const { currentPage, cardsPerPage } = this.state;

    const offset = currentPage;
    const limit = cardsPerPage;

    const response = await axios.get(`${GetBaseUrl()}/api/user/myVideos_pagination2`, {
      headers: { Authorization: `Bearer ${token}`, },
      params: { 
        provider: this.provider,
        offset,
        limit
      } 
    });

    this.setState({
      myVideos: response.data.data.dataArr,
      totalVideos: response.data.data.itemCount
    })

    if (Array.isArray(response.data.data.dataArr)) {
      response.data.data.dataArr.forEach(item => {
        if (item.state === "Waiting") {
          setTimeout(() => {
            this.refreshVideoState(item._id)
          }, 5000)
        }
      })

      this.beginReqRenderProgress();
      if (this.renderingProgressTimer) clearInterval(this.renderingProgressTimer);
      this.renderingProgressTimer = setInterval(this.beginReqRenderProgress, 5000);
    }
  }

  componentDidMount() {
    if (!this.props.isMounted) return
    this.getMyvideo()
    this._isMounted = true
  }

  componentWillUnmount() {
    if (this.renderingProgressTimer) clearInterval(this.renderingProgressTimer);
    this._isMounted = false
  }
  //렌더링 시작시작이 2시간이 지났는지 확인 
  getIsRenderOverTime(startDate) {
    if (!startDate) return true;
    
    const renderStrDate = new Date(startDate)
    const nowDate = new Date();
    const isOvertime = ((nowDate - renderStrDate) / 1000) >= (60 * 60 * 2)
    return isOvertime;
  }

  renderingProgressTimer
  beginReqRenderProgress = async () => {
    const { myVideos } = this.state
    if (!myVideos) return
    const token = localStorage.getItem("token")

    const renderVideos = {}
    myVideos.forEach(item => {
      if (item.state === 'Rendering' || (item.gif && item.gif.state && (item.gif.state === "Rendering" || item.gif.state === "Waiting"))) {
        if (!this.getIsRenderOverTime(item.setStateDate)) renderVideos[item._id] = { region: item.region || 'KR' }
      }
    })

    if (Object.keys(renderVideos).length === 0) //렌더중인 비디오가 없다면 타이머 삭제
    {
      if (this.renderingProgressTimer) clearInterval(this.renderingProgressTimer);
      return;
    }

    for (var key in renderVideos) {
      try {
        const axiosResult = await axios.get(
          `${GetOriginalBaseUrl(renderVideos[key].region)}/api/video/getUserVideoRenderedPercentage/${key}`,
          {
            headers: { Authorization: `Bearer ${token}` }
          });
        renderVideos[key] = { ...axiosResult.data };
      }
      catch (err) {
        this.refreshVideoState(key)
      }
    }

    this.setState({ renderingVideos: renderVideos });
  }

  refreshVideoState = async id => {
    if (!this._isMounted) return

    const token = localStorage.getItem('token')
    try {
      const response = await axios.get(
        `${GetBaseUrl()}/api/user/myVideo`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { id, provider: this.provider }
        })

      if (response && response.data) {
        const { data } = response.data
        const { myVideos } = this.state
        let { selectedVideo } = this.state
        if (!myVideos) return

        let waitingFlag = false
        let renderingFlag = false

        for (let i = 0; i < myVideos.length; i++) {
          if (myVideos[i]._id === id) {
            if (data.state === "Waiting") {
              waitingFlag = true
            }
            if (data.state === "Rendering") {
              renderingFlag = true
              // TODO :: 추후에 렌더링 오랫동안 안끝나면 Error 상태 처리 필요
              // if (data.setStateDate && this.getIsRenderOverTime(data.setStateDate)) {
              //   data.state = "Error"
              // }
            }
            if (data.gif) {
              if (data.gif.state === "Waiting") waitingFlag = true
              else if (data.gif.state === "Rendering") renderingFlag = true
            }
            if (data.thumbnailURL) data.thumbnailURL = `${data.thumbnailURL}?${new Date().getTime()}`
            myVideos[i] = {
              ...myVideos[i],
              ...data
            }

            if (selectedVideo && selectedVideo._id === id) {
              selectedVideo = { ...selectedVideo, ...data }
              this.setState({ selectedVideo: { ...selectedVideo } })
            }
            break
          }
        }
        this.setState({ myVideos }, () => {
          if (waitingFlag) {
            setTimeout(() => {
              this.refreshVideoState(id)
            }, 5000)
          }
          if (renderingFlag) {
            if (this.renderingProgressTimer) clearInterval(this.renderingProgressTimer);
            this.renderingProgressTimer = setInterval(this.beginReqRenderProgress, 5000);
          }
        })
      }
    }
    catch (e) {

    }
  }

  openDialog = (focusedDialogName, videoId, layered, gif = null) => event => {
    if (!layered || layered.state === RENDER_STATE.RENDERING || layered.state === RENDER_STATE.WAITING) {
      return;
    }

    if (gif && (gif.state === RENDER_STATE.RENDERING || gif.state === RENDER_STATE.WAITING)) {
      return;
    }

    this.setState({
      isDialogOpened: true,
      focusedDialogName,
      selectedVideoId: videoId || null
    });
  };
  closeDialog = () => {
    this.setState({ isDialogOpened: false, focusedDialogName: "" });
  };
  onThumbnailClicked = (videoId, templateId, layered, isEditable, gif, isStoreExpired) => async event => {
    if (!layered) {
      this.openDialog("VideoDialog", videoId, layered, gif);
      return;
    }

    if (layered.state === RENDER_STATE.EMPTY) {
      this._onVideoEditClicked(videoId, templateId, layered, isEditable, gif, isStoreExpired)
      return;
    }

    if (layered.state === RENDER_STATE.WAITING || layered.state === RENDER_STATE.RENDERING) {
      return;
    }

    if (gif && (gif.state === RENDER_STATE.WAITING || gif.state === RENDER_STATE.RENDERING)) {
      return
    }

    // 이건 계정 정지 시 다운로드 막는거 (false이면 정지, undefined면 아직 서버 통신 안된거)
    if (this.props.accountStatus.isDownloadable === undefined) {
      return
    }

    if (this.props.accountStatus.isDownloadable === false) {
      return alert(i18n.t("myvideo.alert.block.download.id"))
    }

    let isNoPayment = true
    const { currentUser, paymentMode, pointTicket } = this.props
    if (paymentMode || pointTicket || currentUser.admin) {
      isNoPayment = false
    }
    else {
      try {
        const response = await axios.post(`${GetBaseUrl()}/api/video/paymentcheck`, { id: videoId },
          {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          }
        )
        if (response && response.data && response.data.message === 'success') {
          isNoPayment = response.data.isNoPayment
        }
      }
      catch (e) {
        console.log(e)
      }
    }

    if (isNoPayment) {
      if (!window.MezzoVideoAD) {
        return alert(i18n.t('adsdialog.adblock.alert'))
      }
    }

    this.setState({
      isDialogOpened: true,
      focusedDialogName: "VideoDialog",
      selectedVideoId: videoId,
      isNoPayment
    });
  };

  openFailMoveEditVideoPage = () => {
    this.setState({
      isBtnDialogOpened: true,
      dialogType: "failMoveEditVideoPage"
    })
  }

  getSelectedVideo = (videoId) => {
    const { myVideos } = this.state
    if (!myVideos || myVideos.length === 0) return null

    const selectedVideo = myVideos.filter(video => video._id === videoId)[0]
    return selectedVideo
  }

  onVideoEditClicked = (videoId, templateId, layered, isEditable, gif = null, isStoreExpired) => event => {
    this._onVideoEditClicked(videoId, templateId, layered, isEditable, gif, isStoreExpired)
  }

  _onVideoEditClicked = async (videoId, templateId, layered, isEditable, gif = null, isStoreExpired = true) => {
    const { paymentMode, pointTicket, currentUser, coupons, accountStatus } = this.props
    const provider = DataManager.GetProvider()
    const isValidCoupon = coupons ? coupons.some((item) => DataManager.IsValidCoupon(item, provider)) : false
    const isFreeUser = accountStatus && accountStatus.isExpiredFreePeriod && accountStatus.isExpiredFreePeriod
    const isPremiumUser = paymentMode || pointTicket || currentUser.admin

    // 보관 기간이 만료된 경우
    if (isStoreExpired) return

    if (!templateId || templateId === '') return alert(i18n.t("VideoDialog.renderVideo.error"))

    if (!layered || layered.state === RENDER_STATE.WAITING || layered.state === RENDER_STATE.RENDERING) {
      return;
    }

    if (gif && (gif.state === RENDER_STATE.WAITING || gif.state === RENDER_STATE.RENDERING)) {
      return
    }
    this.setState ({ selectedVideoId: videoId })

    try {
      const token = TokenHelper.GetToken()
      const refreshtoken = TokenHelper.GetRefreshToken()

      await axios.get(`${GetBaseUrl()}/api/auth/refresh-verify?refreshtoken=${refreshtoken}`, { headers: { Authorization: `Bearer ${token}` } })
    }
    catch (e) {
      if (e && e.response && e.response.status === 401) {
        alert(i18n.t("global.expired.session"))
        Logout()
        this.props.history.push('/')
        return
      }
    }

    if (!isEditable && isValidCoupon) return this.handleUseCouponDialogOpen()
    if (!isEditable && !isValidCoupon)  return this.handlePayDialogOpen()

    try {
      // Block User Check (어드민에서 편집정지한 유저)
      const token = TokenHelper.GetToken()
      const url = `${GetBaseUrl()}/api/video/editable`
      const body = { _id: videoId }
      const config = { headers: { Authorization: `Bearer ${token}` } }
      const res = await axios.post(url, body, config)

      if (res.data.result === 'disableedit') return alert('myvideo.alert.block.edit.id')
      else if (res.data.result !== 'success') return this.openFailMoveEditVideoPage()
      
      // 어드민 or 이용권 or 편당결제 or 워터마크제거 or 무료유저
      if (isEditable) return this.videoEdit(videoId)

      // 정상적이면 여기까지 오는일은 없으나 유지보수중 발생할 수 있는 예외적인 상황
    }
    catch (e) {
      console.log(e)
      this.openFailMoveEditVideoPage()
    }
  };

  handleAlertDialogOpen=(dialogType)=>{
    this.setState({ dialogType, isBtnDialogOpened: true });
  }

  handleGIFDIalogClose = () => {
    this.setState({
      GifCropDialogProps: {
        ...this.state.GifCropDialogProps,
        open: false,
        src: null,
        videoId: null,
      }
    })
  }

  handleGIFDialogOpen = async (selectedVideo) => {
    const { paymentMode, currentUser, pointTicket, } = this.props
    if (!selectedVideo) return
    if (!paymentMode && !currentUser.admin && !pointTicket) return alert(i18n.t("web.myvideo.gif.isnopayment"))

    if (selectedVideo.state === "Waiting" || selectedVideo.state === "Rendering") return this.handleAlertDialogOpen("renderingGif");
    this.closeDialog();
    this.setState({
      GifCropDialogProps: {
        ...this.state.GifCropDialogProps,
        onClose:this.handleGIFDIalogClose,
        onComplete:this.onGIFRangeEditComplete,
        open: true,
        src: selectedVideo.url,
        videoId: selectedVideo._id,
      },
      selectedVideo
    })
  }

  onGIFDownload = async (gifUrl, videoName) => {
    try {
      const response = await axios.get(`${gifUrl}?date=${Date.now().toString()}`, {
        responseType: "blob"
      })
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = `${videoName}.gif`;
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      const { currentUser } = this.props;
      const userId = currentUser ? currentUser._id : null;
      ErrorHandler(this, userId, e, { alert: true, log: true, server: true });
    }
  }

  onGIFRangeEditComplete = async (videoId, startPoint, duration) => {
    try {
      const token = DataManager.GetToken();
      const { result, data } = await VideosApis.PostGifRender(token, { videoId, startPoint, duration });

      if (result && data === "success") {
        const { myVideos, selectedVideo } = this.state
        for (let i = 0; i < myVideos.length; i++) {
          if (myVideos[i]._id === videoId) {

            myVideos[i] = {
              ...myVideos[i],
              state: "Waiting",
              gif: {
                url: null,
                state: 'Waiting'
              }
            }
            selectedVideo.gif ? selectedVideo.gif.state = 'Waiting' : selectedVideo.gif = { url: null, state: 'Waiting'}
            break
          }
        }
        this.setState({ myVideos, selectedVideo }, () => {
          setTimeout(() => {
            this.refreshVideoState(videoId)
          }, 5000)
      })
      }else{
        switch (data){
          case PUBLIC_ERROR_CODE.ERR_NOT_FOUND: return alert(i18n.t("web.myvideo.alert.video.not.found"))
          case PUBLIC_ERROR_CODE.ERR_CAN_NOT_GIF_RENDER: return alert(i18n.t("myvideo.alert.gif.render.error"));
          case PUBLIC_ERROR_CODE.ERR_INVALID_ACCESS: return alert(i18n.t("web.myvideo.copy.isnopayment"));
          default: alert("global.failed.unknown");
        }
      }
    } catch (e) {
      if (e && e.response && e.response.status === 401) {
        alert(i18n.t("global.expired.session"))
        Logout();
        return
      }else{
        const { currentUser } = this.props;

        const userId = currentUser ? currentUser._id : null;
        ErrorHandler(this, userId, e, { server: true, alert: true });
      }
    }
  }

  onDownloadClicked = async (videoId, videoName, isDownloadable, layered) => {
    // 이건 계정 정지 시 다운로드 막는거 (false이면 정지, undefined면 아직 서버 통신 안된거)
    if (this.props.accountStatus.isDownloadable === undefined) {
      return
    }

    if (this.props.accountStatus.isDownloadable === false) {
      return alert(i18n.t("myvideo.alert.block.download.id"))
    }

    if (!isDownloadable) {
      return;
    }

    if (layered) {
      if (layered.state === RENDER_STATE.RENDERING) return
      if (layered.state === RENDER_STATE.WAITING) return
      if (layered.state === RENDER_STATE.ERROR) return
      if (layered.state === RENDER_STATE.EMPTY) return
    }

    const token = localStorage.getItem("token")
    if (token) {
      try {
        const response = await axios.get(`${GetBaseUrl()}/api/video/downloadvideo?id=${videoId}`, {
          headers: { Authorization: `Bearer ${token}` }
        })

        if (response && response.data && response.data.url) {
          const { url } = response.data
          axios.get(`${url}?date=${Date.now().toString()}`, {
            responseType: "blob"
          }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.download = `${videoName}.mp4`;
            link.click();
          })
            .catch(e => {
              if (e instanceof Error) {
                const { message, name, stack } = e
                axios.post(`${GetBaseUrl()}/api/system/app-error-log`, {
                  id: 'myvideo',
                  log: JSON.stringify({
                    message,
                    name,
                    stack
                  }),
                  deviceInfo: {}
                }).catch(() => { })
              }
              window.open(`${url}?date=${Date.now().toString()}`, '_blank')
            })
        }
      }
      catch (e) {
        if (e && e.response && e.response.status) {
          switch (e.response.status) {
            case 401:
              break

            case 400:
            case 404:
            case 500:
            default:
              alert('Server Error : ' + e.response.status)
              break
          }
        }
        else {
          if (e instanceof Error) {
            const { message, name, stack } = e
            axios.post(`${GetBaseUrl()}/api/system/app-error-log`, {
              id: 'myvideo',
              log: JSON.stringify({
                message,
                name,
                stack
              }),
              deviceInfo: {}
            }).catch(() => { })
          }
          alert('Server Error : Unknown')
        }
      }
    }
  };
  onDeleteClicked = videoId => event => {
    const token = localStorage.getItem("token");

    const axiosRegionResult = axios.get(
      `${GetBaseUrl()}/apis/videos/${videoId}/region`,
      { headers: { Authorization: `Bearer ${token}` } }
    )

    axiosRegionResult
      .then(regionResult => {
        const axiosResult = axios.post(
          `${GetOriginalBaseUrl(regionResult.data.data.region)}/api/user/video`,
          {
            video_id: videoId
          },
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        axiosResult
          .then(res => {
            this.onMyVideoDeleted(videoId);

          })
          .catch(error => {
            //console.log("마이 비디오 삭제 실패... 스크린샷으로 문의해주세요", error);
            //console.log("마이 비디오 삭제 실패 에러", error);
          })
      })
      .catch(error => {})

    this.closeDialog();
  };

  onPageNumberClicked = newPage => event => {
    this.setState({ currentPage: newPage }, () => {
      this.getMyvideo();
    });
  };
  onPreviousPageClicked = newPage => event => {
    this.setState({ currentPage: newPage }, () => {
      this.getMyvideo();
    });
  };
  onNextPageClicked = newPage => event => {
    this.setState({ currentPage: newPage }, () => {
      this.getMyvideo();
    });
  };
  videoEdit = (videoId) => {
    this.props.history.push({ pathname: `/makevideo`, search: `?id=${videoId}`, state: { edit: true } });
  }
  onViewAllFreeVideosButtonClicked = () => {
    const { history } = this.props
    history.push(ROUTE_PATH.DESIGN_SELECT);
  }
  popupHandleCloseBtn = () => {
    this.setState({
      isBtnDialogOpened: false
    })
  }

  onMyVideoDeleted = deletedVideoId => {
    const targetVideo = this.state.myVideos && this.state.myVideos.filter(myVideo => myVideo._id === deletedVideoId)
    if (targetVideo.length === this.state.myVideos.length && this.state.currentPage > 0) {
      this.onPreviousPageClicked(this.state.currentPage - 1)();
    }
    else {
      this.getMyvideo();
    }
  };
  clickRemoveTemplate = () => () => {
    // this.setState({
    //   userRemoveTemplate: false
    // });
  };
  SettingClick = (id, layered) => {
    if (!layered) {
      return;
    }

    if (layered.state === "Rendering") {
      return;
    }

    if (layered.state === "Waiting") {
      return;
    }

    this.setState({
      isOpenSettingDropdown: !this.state.isOpenSettingDropdown,
      videoId: id
    })
  }
  handleClickAway = () => {
    this.setState({
      isOpenSettingDropdown: false,
    })
  }
  // 제목변경 팝업 열기
  handleChangeTitle = (video) => {
    this.setState({ isChangeTitleInputDialog: true, selectedVideo: video })
  }
  // 제목변경 팝업 닫기
  closeChangeTitleInputDialog = () => {
    this.setState({ isChangeTitleInputDialog: false })
  }
  changeTitle = (event) => {
    this.setState({ title: event.target.value });
  }
  onTitleSubmitButtonClicked = () => {
    if (this.state.title.length === 0) {
		return alert(i18n.t("examineshopdialog.placeholder.title"));
    }
    const token = localStorage.getItem("token");
    let _id = this.state.selectedVideo._id
    const axiosResult = axios.post(
      `${GetBaseUrl()}/api/video/rename`,
      {
        _id,
        name: this.state.title
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    axiosResult
      .then(res => {
        const { myVideos, title: name } = this.state
        if (myVideos) {
          for (let i = 0; i < myVideos.length; i++) {
            if (myVideos[i]._id === _id) {
              myVideos[i].name = name
              break
            }
          }
        }

        this.setState({ myVideos, isChangeTitleInputDialog: false, videoId: "", title: "" });
      })
      .catch(error => {
        alert(i18n.t("onebtndialog.failEditVideo.dialogBodyText2"), error);
      });
  }
  // 공유 버튼 클릭시 활성화 되는 팝업창
  handleClickShareIcon = (video) => {
    this.setState({ isShareDialogOpen: true, selectedVideo: video })
  }
  //공유 팝업창 끄는 함수
  closeShareDialog = () => {
    this.setState({ isShareDialogOpen: false })
  }

  clickShareItem = async method => {
    const item = this.state.selectedVideo
    if (item.state === 'Empty' || item.state === 'Rendering' || item.state === 'Waiting') return
    try {
      const response = await axios.get(`${GetBaseUrl()}/api/video/share-link?id=${item._id}`)
      if (response && response.data && response.data.result === 'success') {
        const { shareId } = response.data
        const shareLink = window.location.origin + `/share?id=${shareId}`
        const { invokeCSharpAction } = window
        const isXamarin = invokeCSharpAction

        switch (method) {
          case 'twitter':
          case 'facebook':
            let targetLink = 'about:blank'

            if (method === 'twitter') targetLink = 'https://twitter.com/intent/tweet?url=' + shareLink
            else if (method === 'facebook') targetLink = 'https://www.facebook.com/sharer/sharer.php?u=' + shareLink

            if (isXamarin) window.location.href = targetLink
            else {
              const windowRef = window.open(targetLink, '_blank')
              if (!windowRef) this.setState({
                isBtnDialogOpened: true,
                dialogType: "shareLinkBlock"
              })
            }
            break

          case 'linkxamarin':
            window.invokeCSharpAction(`method=linkshare&url=${shareLink}`)
            break

          case 'link':
          default:
            CopyToClipboard(shareLink)
            this.setState({
              isBtnDialogOpened: true,
              dialogType: "shareSuccess"
            })
            break
        }
      }
    }
    catch (e) {
      this.setState({
        isBtnDialogOpened: true,
        dialogType: "shareFail"
      })
    }
  }

  handlePayDialogOpen = () => this.setState({ isOpenPayTwoButton: true })
  handleClosePayDialog = () => this.setState({ isOpenPayTwoButton: false })
  handleClickPay = () => this.props.history.push('/payment')

  handleUseCouponDialogOpen = () => this.setState({ isOpenUseCouponTwoButton: true })
  handleCloseUseCouponDialog = () => this.setState({ isOpenUseCouponTwoButton: false })
  handleClickUseCoupon = async (selectedVideo, isMoveEditor = false) => {
    try {
        const { coupons } = this.props
        const token = DataManager.GetToken()
        const provider = DataManager.GetProvider()
        const productId = DataManager.GetProductId(provider).PRODUCT_ID
        const couponInfo = DataManager.GetCouponInfo(coupons, provider)

        const response = await PaymentsApis.PostFreePayment(token,
          {
            productId,
            templateId: selectedVideo && selectedVideo.template._id,
            videoId: selectedVideo && selectedVideo._id,
            couponId: couponInfo && couponInfo._id,
          }
        )
        if (response.result) {
            FetchCoupons()
            if (isMoveEditor) {
                this.props.history.push({
                  pathname: '/makevideo',
                  search: `?id=${selectedVideo && selectedVideo._id}`
                })
            }
            this.handleCloseUseCouponDialog()
          }
    }
    catch (e) {
        const { currentUser } = this.props
        const userId = currentUser ? currentUser._id : null
        ErrorHandler(this, userId, e, { log: true, server: true })
        alert("Error")
    }
}
  // 워터마크 제거 함수
  handleRemoveWaterMark = layered => video => {
    if (!layered || layered.state === RENDER_STATE.RENDERING || layered.state === RENDER_STATE.WAITING) {
      return;
    }

    if (video.gif && (video.gif.state === RENDER_STATE.RENDERING || video.gif.state === RENDER_STATE.WAITING)) {
      return;
    }

    this.setState({ isOpenWaterMarkTwoButton: true, selectedVideo: video, selectedVideoId: video._id })
  }
  closeWaterMarkTwoButton = () => this.setState({ isOpenWaterMarkTwoButton: false })
  clickRemoveWaterMark = () => {
    const { selectedVideo } = this.state
    if (!selectedVideo) return

    const { _id, template } = selectedVideo
    if (_id && template && template._id) {
      if (this.props.value === 'ko') {
        this.props.history.push({
          pathname: '/payment/orderReview',
          state: {
            productId: '6396d22ac2cb943c9069736b',
            isRemoveWatermark: true
            // selectedTemplateId: template._id,
            // videoId: _id
          }
        })
      }
      else if (this.props.value === 'jp') {
        this.props.history.push({
          pathname: '/payment/orderReview',
          state: {
            // productId: '5ff3cc2d2432063ebc463495',

            // EVENT LOGIC START
            productId: '61a47944fb0b9a903317f71a', // TODO
            // EVENT LOGIC END
            selectedTemplateId: template._id,
            videoId: _id
          }
        })
      }
      else {
        this.props.history.push({
          pathname: '/payment/orderReview',
          state: {
            // productId: '5e58d30c4b987c89378d8ad7',

            // EVENT LOGIC START
            productId: '61a47923fb0b9a903317f719', // TODO
            // EVENT LOGIC END

            selectedTemplateId: template._id,
            videoId: _id
          }
        })
      }
    }
    else alert("Error")
    
    this.setState({ isOpenWaterMarkTwoButton: false })
  }

  handleGalleryUploadDialogOpen = async video => {
    if (!video) return

    try {
      const isGalleryOpen = Boolean(video.isGalleryOpen)
      const focusedDialogName = !isGalleryOpen ? "GalleryUpload" : "GalleryUploadCancel"

      this.setState({ selectedVideo: video })
      this.openDialog(focusedDialogName, video._id, video)()
    }
    catch (e) {

    }
  }

  handleVideoInfoDialogOpen = (video) => {
    try {
      if (!video) return;
      let templateName = "";
      let videoName = video ? video.name : "";
      let musicName = "";
      let fontMap = {}
      let fontNames = [];
  
      const template = video.template;
      if (video.material) {
        const material = JSON.parse(video.material);
        if(material.Music) musicName = material.Music.Name;
        if(material.Text && material.Text.length) {
          material.Text.forEach(text => {
            if(text.option && text.option.Font) fontMap[text.option.Font.postscriptName] = true;
          });
        } 
      }
      if (template) {
          const { name, templateData, musicInfo } = template;
          const { FontBlobURL } = templateData;
          if (name) templateName = name;
          if (!musicName && musicInfo && musicInfo.name) musicName = musicInfo.name;
          if (FontBlobURL) Object.keys(FontBlobURL).forEach(key => { fontMap[key] = true; });
      }
      fontNames = Object.keys(fontMap);

      this.setState({
        isVideoInfoDialogOepn: true,
        videoInfo: {
          name: templateName,
          videoName,
          fonts: fontNames,
          music: musicName
        }
      });
    }
    catch (e) {
      console.error(e);
    }
  }
  
  handleVideoInfoDialogClose= () => {
    this.setState({isVideoInfoDialogOepn:false});
  }

  galleryUpload = () => async () => {
    const { selectedVideo: video } = this.state
    if (!video) return
    // if (video.isUsedMyMusic) return alert(i18n.t("web.gallery.used.custom.music"))

    const token = localStorage.getItem("token");
    let {myVideos} = this.state
    let isGalleryUpload;
    if (video.isGalleryOpen) {
      isGalleryUpload = false
    } else {
      isGalleryUpload = true
    }
    try {
      await axios.post(`${GetBaseUrl()}/api/video/gallery-open`,
        {
          id: video._id,
          isOpen: isGalleryUpload
        },
        { headers: { Authorization: `Bearer ${token}` } });
      if (isGalleryUpload) {
        this.setState({
          isBtnDialogOpened: true,
          dialogType: "galleryUploadSuccess"
        })
      } else {
        this.setState({
          isBtnDialogOpened: true,
          dialogType: "galleryDelete"
        })
      }
      for(let i=0; i < myVideos.length; i++){
        if(myVideos[i]._id === video._id){
            myVideos[i].isGalleryOpen = isGalleryUpload
            this.setState({
              myVideos
            })
        }
      }
    } catch (err) {
      console.log(err)
    }
    this.closeDialog()
  }

  handleVideoCopy = async video => {
    if (!video) return
    const { paymentMode, currentUser, pointTicket } = this.props
    if (!paymentMode && !currentUser.admin && !pointTicket) return alert(i18n.t("web.myvideo.copy.isnopayment"))

    const token = localStorage.getItem("token")
    this.setState({ isUploading: true })

    try {
      await axios.post(
        `${GetOriginalBaseUrl(video.region)}/apis/videos/${video._id}/copy`, {},
        {
          headers: { Authorization: `Bearer ${token}` }
        })

      this.getMyvideo()
    }
    catch (e) {
      alert(i18n.t('web.myvideo.copy.failed'))
    }

    this.setState({ isUploading: false })
  }

  handleOpenThumbnailDialog = async (_id, thumbnail) => {
    try {
      const token = localStorage.getItem("token")
      const { result, data } = await VideosApis.GetVideoPrviews(token, { templateId: _id });

      if(!result) return;


      this.setState({
        selectedVideoId: _id,
        previews:data,
        selectedThumbnail: thumbnail,
        isDialogOpened: true,
        focusedDialogName: 'ThumbnailDialog'
      })
    }
    catch (e) {
      const { currentUser } = this.props;

      const isServer = currentUser ? true : false;
      const userId = isServer ? currentUser._id : null;

      ErrorHandler(this, userId, e, { alert: true, log: true, server: isServer });
    }
  }

  handleAddCustomThumbnail = e => {
    const { uploadImgBloburl } = this.props
    if (e.target.files[0].size > USER_SOURCE_UPLOAD_POLICY.LimitSize.Thumbnail) {
      alert(i18n.t("web.changethumbnail.direct-image-upload.description")
        .replace("{LIMIT}", USER_SOURCE_UPLOAD_POLICY.LimitSize.Thumbnail / 1024 / 1024))
    }
    else {
      const src = URL.createObjectURL(e.target.files[0])

      const image = new Image()
      image.src = src

      image.onload = () => {
        const max = Math.max(image.width, image.height)
        const min = Math.min(image.width, image.height)

        if (max / min > 2) return alert(i18n.t("web.changethumbnail.direct-image-upload.invalid.ratio"))

        uploadImgBloburl.push(src)
        ReduxBinding(REDUX_ACTION.UPLOAD_IMG_BLOBURL, [ ...uploadImgBloburl ])
      }
    }
    e.target.value = ''
  }

  handleUseCoupon = ({ templateId, videoId }) => {
    const { coupons } = this.props;
    const token = DataManager.GetToken()
    const provider = DataManager.GetProvider()
    return new Promise(async (resolve, reject) => {
      const productId = DataManager.GetProductId(provider).PRODUCT_ID
      const couponInfo = DataManager.GetCouponInfo(coupons, provider);
      const body = {
        productId,
        templateId,
        videoId,
        couponId: couponInfo._id,
      }
      if (this.provider) body.provider = this.provider;
      const response = await PaymentsApis.PostFreePayment(token, body);
      if (!response.result) {
        return reject(false)
      }
      resolve(true);
    })
  }

  handleChangeThumbnail = async (_id, index, type) => {
    try {
      const { uploadImgBloburl } = this.props
      const { myVideos, previews } = this.state
      this.closeDialog()

      let url
      const token = localStorage.getItem("token")
      if (type === 'previews') {
        url = previews[index]
        await axios.patch(`${GetBaseUrl()}/apis/videos/${_id}/thumbnail`, { index }, { headers: { Authorization: `Bearer ${token}` } })
      }
      else if (type === 'custom') {
        url = uploadImgBloburl[index]

        const response = await axios.get(url, { responseType: 'blob' })
        const blob = response.data

        const formData = new FormData()
        formData.append('source', blob, `${Date.now()}.${blob.type.split('/')[1]}`)

        this.setState({ isUploading: true })

        const regionResponse = await axios.get(
          `${GetBaseUrl()}/apis/videos/${_id}/region`,
          { headers: { Authorization: `Bearer ${token}` } }
        )

        await axios.post(`${GetOriginalBaseUrl(regionResponse.data.data.region)}/apis/videos/${_id}/thumbnail/upload`, formData, { headers: { Authorization: `Bearer ${token}` } })
      }

      for (let i = 0; i < myVideos.length; i++) {
        if (myVideos[i]._id === _id) {
          myVideos[i].thumbnailURL = url
          break
        }
      }
      this.setState({ myVideos })
    }
    catch (e) {
      alert('Error')
    }
    this.setState({ isUploading: false })
  }

  getBinaryContent = (url) => {
    return new Promise((resolve) => {
      JszipUtils.getBinaryContent(url, (err, data) => {
        if (err) return;
        resolve(data)
      })
    })
  }

  handleThumbnailAllDownload = async (templateName, templateId) => {
    try {
      const { paymentMode, currentUser, pointTicket } = this.props
      if (!paymentMode && !currentUser.admin && !pointTicket) return alert(i18n.t("web.myvideo.thumbnail.download.isnopayment"));

      const token = DataManager.GetToken();
      const { result, data } = await VideosApis.GetVideoPrviews(token, { templateId })

      if (!result) return;

      const jszip = new JSzip();
      await Promise.all(data.map(async (thumbnailURL) => {
        const urlSpilt = thumbnailURL.split("/");
        const urlLength = urlSpilt.length;
        const fileName = urlSpilt[urlLength - 1];
        const binaryContent = await this.getBinaryContent(thumbnailURL)
        jszip.file(fileName, binaryContent, { binary: true });
      }))

      jszip.generateAsync({ type: 'blob' }).then((blob) => {
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.href = url;
        a.download = `${templateName}.zip`;
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
    } catch (e) {
      const { currentUser } = this.props;

      const isServer = currentUser ? true : false;
      const userId = isServer ? currentUser._id : null;

      ErrorHandler(this, userId, e, { alert: true, log: true, server: isServer });
    }
  }

  handleOpenOtherRatioDialog = () => {
    const { paymentMode, currentUser, pointTicket } = this.props;
    if (!paymentMode && !currentUser.admin && !pointTicket) return alert(i18n.t("web.myvideo.ratio.isnopayment"));
    this.setState({ isOpenOtherRatioDialog: true })
    this.closeDialog()
  }

  handleCloseOtherRatioDialog = () => {
    this.setState({ isOpenOtherRatioDialog: false })
  }

  handleChangeRatio = async (videoId, templateId) => {
    if (!videoId || !templateId) return;

    const token = DataManager.GetToken();
    try {
      this.setState({ isUploading: true });
      const { result, data } = await VideosApis.PostChangeTemplate(token, { templateId, videoId });
      if (result && data) {
        const { material, videoId } = data
        const cutModified = JSON.stringify({ modified: {}, deleted: {} })
        const body = {
          type: "video",
          _id: videoId,
          name: "myvideo",
          material,
          cutModified,
        }
        await VideoApis.PostVideoRendering(token, body);
        this.getMyvideo();
      }
      this.setState({ isUploading: false });
    } catch (e) {
      const { currentUser } = this.props;

      const isServer = currentUser ? true : false;
      const userId = isServer ? currentUser._id : null;
      this.setState({ isUploading: false });
      ErrorHandler(this, userId, e, { alert: true, log: true, server: isServer });
    }
  }

  getVideoThumbnailImage = video => {
    if (video.thumbnailURL) {
      // 임시처리 > 1시간마다 썸네일 업데이트
      return video.thumbnailURL + `?date=${new Date().toISOString().substring(0, 13)}`
      // if (video.thumbnailURL.startsWith('blob:')) return video.thumbnailURL
      // else return TemplateHelper.ConvertURLToSmallURL(video.thumbnailURL)
    }
    if (video.template) return TemplateHelper.getThumbnailImage(video.template, video.lang, true)
    return ""
  }

  render() {
    const Waiting = {
      state: "Waiting",
      iconUrl: "https://front.videomonster.com/images-7cuytg20/web/myvideo/waiting.png",
      text: i18n.t("myvideo.waiting.text"),
      textBackgroundColor: "none",
      confirmationDialog: {
        title: i18n.t("myvideo.waiting.title"),
        message:
          i18n.t("myvideo.waiting.message")
      }
    };
    const Rendering = {
      state: "Rendering",
      iconUrl: "",
      text: i18n.t("myvideo.rendering.text"),
      textBackgroundColor: "none",
      confirmationDialog: {
        title: i18n.t("myvideo.rendering.title"),
        message:
          i18n.t("myvideo.rendering.message")
      }
    };

    const Finish = {
      state: "Finish",
      iconUrl: FinishedLayerIcon,
      text: i18n.t("myvideo.finish.text"),
      textBackgroundColor: "none",
      confirmationDialog: {
        title: i18n.t("myvideo.finish.title"),
        message:
          i18n.t("myvideo.finish.message")
      }
    }

    const Empty = {
      state: "Empty",
      iconUrl: EmptyLayerIcon,
      text: i18n.t("myvideo.empty.text"),
      textBackgroundColor: "none",
      confirmationDialog: {
        title: i18n.t("myvideo.empty.title"),
        message:
          i18n.t("myvideo.empty.message")
      }
    }

    const ErrorState = {
      state: "Error",
      iconUrl: '',
      text: i18n.t("myvideo.error.text"),
      textBackgroundColor: "none",
      confirmationDialog: {
        title: i18n.t("myvideo.error.title"),
        message:
          i18n.t("myvideo.error.message1_1") +
          i18n.t("myvideo.error.message1_2") +
          i18n.t("myvideo.error.message1_3")
      }
    }

    const renderStateTable = {
      Empty,
      Waiting,
      Rendering,
      Finish,
      Error: ErrorState
    };
    const { myVideos, isOpenWaterMarkTwoButton, isOpenPayTwoButton, isOpenUseCouponTwoButton, totalVideos } = this.state;
    let { currentPage, cardsPerPage } = this.state;

    if (myVideos) {
      let maxPageCount = Math.floor((totalVideos - 1) / cardsPerPage)
      if (maxPageCount < 0) maxPageCount = 0
      if (currentPage > maxPageCount) currentPage = maxPageCount
    }

    if (myVideos === undefined) {
      return <Loading />;
    }

    const selectedVideo = myVideos.filter(
      video => video._id === this.state.selectedVideoId
    )[0];
    const renderStateTableData = selectedVideo
      ? renderStateTable[selectedVideo.state]
      : undefined

    const confirmationDialogDatas = renderStateTableData
      ? renderStateTable[selectedVideo.state].confirmationDialog
      : undefined;

    const { paymentMode, currentUser, pointTicket, coupons } = this.props
    const provider = DataManager.GetProvider()
    const isExistPayment = paymentMode || pointTicket || (currentUser && currentUser.admin);
    const isValidCoupon = coupons ? coupons.some((item) => DataManager.IsValidCoupon(item, provider)) : false
    const isPointUiShow = getIsExpiredDate(POINT_UI_EXPIRED_DATE);
    const isProviderCafe24 = DataManager.IsProvider(DataManager.PROVIDER.CAFE24);
    return (
      <>
        {this.props.value === "en" ?
          <VideoCount>{myVideos.length} {i18n.t("myvideo.text.video2")}</VideoCount>
          :
          <VideoCount>{i18n.t("myvideo.text.video1")} {myVideos.length} {i18n.t("myvideo.text.video2")}</VideoCount>
        }

        <div style={{ maxWidth: "1200px", margin: "auto", minHeight: "351px" }}>
          {
            myVideos.length === 0 ? (
              <EmptyVideo
                onViewAllFreeVideosButtonClicked={this.onViewAllFreeVideosButtonClicked}
                text1={i18n.t("myvideo.emptyvideo.text1")}
                text2={i18n.t("myvideo.emptyvideo.text2")}
                btn={true}
              >
              </EmptyVideo>
            ) : (
              <GridContainer>
                {myVideos
                  .map(video => {
                    const layered = renderStateTable[video.state]
                      ? renderStateTable[video.state]
                      : renderStateTable['Empty'];
                    const date = formatDate(video.date);
                    const isStoreExpired = Validator.Boolean(video.isStoreExpired) ? video.isStoreExpired : true
                    return (
                      <Card
                        myvideo
                        isProviderCafe24={isProviderCafe24}
                        video={video}
                        key={video._id}
                        title={
                          video.name === ""
                            ? video.template && video.template.name
                            : video.name
                        }
                        progress={this.state.renderingVideos && this.state.renderingVideos[video._id]}
                        date={date || ""}
                        thumbnailUrl={this.getVideoThumbnailImage(video)}
                        onThumbnailClicked={this.onThumbnailClicked(
                          video._id,
                          (video.template && video.template._id) || '',
                          layered,
                          video.isEditable,
                          video.gif,
                          isStoreExpired
                        )}
                        gifInfo={video.gif}
                        onChangeTitle={this.handleChangeTitle}
                        layered={layered}
                        paymentInfo={video.paymentInfo}
                        isExistPayment={isExistPayment}
                        showGalleryIcons={true}
                        footerComponent={
                          <MyVideoCardFooter
                            video={video}
                            layered={layered}
                            onVideoEditClicked={this.onVideoEditClicked(
                              video._id,
                              (video.template && video.template._id) || '',
                              layered,
                              video.isEditable,
                              video.gif,
                              isStoreExpired
                            )}
                            onVideoInfoOpen={this.handleVideoInfoDialogOpen}
                            isExistPayment={isExistPayment}
                            onRemoveWaterMark={this.handleRemoveWaterMark(layered)}
                            onGIFDownload={this.onGIFDownload}
                            gifUrl={video.gif && video.gif.url}
                            onDownloadClicked={(videoId, videoName, isDownloadable) => this.onDownloadClicked(videoId, videoName, isDownloadable, layered)}
                            onDeleteClicked={this.openDialog(
                              "ConfirmationDialog",
                              video._id,
                              layered,
                              video.gif
                            )}
                          />
                        }
                      />
                    );
                  })}
              </GridContainer>
            )
          }
        </div>

        <VideoDialog
          provider={this.provider}
          closeDialog={this.closeDialog}
          isDialogOpened={
            this.state.isDialogOpened &&
            this.state.focusedDialogName === "VideoDialog"
          }
          onGIFDialogOpen={this.handleGIFDialogOpen}
          thumbnailUrl={selectedVideo ? this.getVideoThumbnailImage(selectedVideo) : undefined}
          selectedVideo={selectedVideo}
          isNoPayment={this.state.isNoPayment}
          renderStateTableData={renderStateTableData}
          onRemoveWaterMark={this.handleRemoveWaterMark(renderStateTableData)}
          onVideoEditClicked={this._onVideoEditClicked}
          onDownloadClicked={this.onDownloadClicked}
          onChangeTitle={this.handleChangeTitle}
          onChangeThumbnail={this.handleOpenThumbnailDialog}
          onCopyVideo={this.handleVideoCopy}
          onShare={this.handleClickShareIcon}
          openDialog={this.openDialog}
          onGalleryUpload={this.handleGalleryUploadDialogOpen}
          onThumbnailDownload={this.handleThumbnailAllDownload}
          isExistPayment={isExistPayment}
          onGIFDownload={this.onGIFDownload}
          onChangeRatio={this.handleOpenOtherRatioDialog}
          value={this.props.value}
        />
        <ConfirmationDialog
          cancleText={i18n.t("global.cancel")}
          deleteText={i18n.t("global.delete")}
          closeDialog={this.closeDialog}
          isDialogOpened={
            this.state.isDialogOpened &&
            this.state.focusedDialogName === "ConfirmationDialog"
          }
          selectedVideoId={this.state.selectedVideoId}
          onDeleteClicked={this.onDeleteClicked}
          title={
            confirmationDialogDatas
              ? confirmationDialogDatas.title
              : i18n.t("myvideo.ask.delete.video.title")
          }
          message={
            confirmationDialogDatas
              ? confirmationDialogDatas.message
              : i18n.t("myvideo.ask.delete.video.text")
          }
        />
        <ConfirmationDialog
          cancleText={i18n.t("global.cancel")}
          deleteText={i18n.t("web.myvideo.gallery.upload.btn")}
          closeDialog={this.closeDialog}
          isDialogOpened={
            this.state.isDialogOpened &&
            this.state.focusedDialogName === "GalleryUpload"
          }
          selectedVideoId={this.state.selectedVideoId}
          onDeleteClicked={this.galleryUpload}
          title={
            isPointUiShow
              ? i18n.t("web.myvideo.gallery.upload.ask.title")
              : i18n.t("web.myvideo.gallery.new.upload.ask.title")
          }
          message={
            isPointUiShow
              ? i18n.t("web.myvideo.gallery.upload.ask.body")
              : null
          }
        />
        <ConfirmationDialog
          cancleText={i18n.t("global.cancel")}
          deleteText={i18n.t("web.myvideo.gallery.delete.btn")}
          closeDialog={this.closeDialog}
          isDialogOpened={
            this.state.isDialogOpened &&
            this.state.focusedDialogName === "GalleryUploadCancel"
          }
          selectedVideoId={this.state.selectedVideoId}
          onDeleteClicked={this.galleryUpload}
          title={i18n.t("web.myvideo.gallery.delete.ask.title")}
          message={
            isPointUiShow
              ? i18n.t("web.myvideo.gallery.delete.ask.body")
              : null
          }
        />
        <PaginationContainer>
          <Pagination2
            currentPage={currentPage}
            cardsPerPage={cardsPerPage}
            itemCount={totalVideos}
            onPageNumberClicked={this.onPageNumberClicked}
            onPreviousPageClicked={this.onPreviousPageClicked}
            onNextPageClicked={this.onNextPageClicked}
          />
        </PaginationContainer>

        {/* props를 부모로부터 내려받기 때문에 onebtndialog 컴포넌트에 넣지 않음 */}
        <UploadCompleted
          DesignedButtonText={i18n.t("global.confirm")}
          dialogBodyText1={i18n.t("myvideo.delete.video.confirm.title")}
          dialogHeadText={i18n.t("global.success")}
          open={this.state.userRemoveTemplate}
          closeUploadCompletedDialog={this.clickRemoveTemplate}
          closeBtn={this.clickRemoveTemplate}
        />

        <OneBtnDialog
          dialogType={this.state.dialogType}
          open={this.state.isBtnDialogOpened}
          closeBtn={this.popupHandleCloseBtn}
          onButtonClick={this.popupHandleCloseBtn}
        />
        {this.state.GifCropDialogProps.open &&
          <GIFCropDialog
            {...this.state.GifCropDialogProps}
            onGIFDownload={this.onGIFDownload}
            selectedVideo={selectedVideo}
          />
        }
        <ChangeTitleInput
          open={this.state.isChangeTitleInputDialog}
          onClose={this.closeChangeTitleInputDialog}
          onTitleSubmitButtonCancel={this.closeChangeTitleInputDialog}
          onChange={this.changeTitle}
          onTitleSubmitButtonClicked={this.onTitleSubmitButtonClicked}
          video={this.state.selectedVideo}
        />
        <ShareDialog
          open={this.state.isShareDialogOpen}
          onClose={this.closeShareDialog}
          onShare={this.clickShareItem}
        />
        <ThumbnailChangeDialog
          closeDialog={this.closeDialog}
          isDialogOpened={
            this.state.isDialogOpened &&
            this.state.focusedDialogName === "ThumbnailDialog"
          }
          selectedVideo={selectedVideo}
          renderStateTableData={renderStateTableData}
          thumbnailImg={this.state.selectedThumbnail}
          customThumbnails={this.props.uploadImgBloburl}
          previews={this.state.previews}
          handleAddCustomThumbnail={this.handleAddCustomThumbnail}
          handleChangeThumbnail={this.handleChangeThumbnail}
        />
        <VideoInfoDialog
          open={this.state.isVideoInfoDialogOepn}
          onClose={this.handleVideoInfoDialogClose}
          videoInfo={this.state.videoInfo}
        />

        <OtherRatioDialog
          open={this.state.isOpenOtherRatioDialog}
          onClose={this.handleCloseOtherRatioDialog}
          selectedVideo={selectedVideo}
          onChangeRatioVideo={this.handleChangeRatio}
          history={this.props.history}
        />

        <TwoBtnDialog header={<Trans i18nKey="charge.paymentwayBox.title6" components={{ br: <br /> }} />} open={isOpenWaterMarkTwoButton} onClose={this.closeWaterMarkTwoButton} onClick={() => isValidCoupon ? this.handleClickUseCoupon(selectedVideo && selectedVideo, true) : this.clickRemoveWaterMark()}>
          <div>{isValidCoupon ? i18n.t("myvideo.watermark.dialog.text") : i18n.t("twoBtndialog.remove.watermark")}</div>
        </TwoBtnDialog>
        <TwoBtnDialog header={<Trans i18nKey={selectedVideo && selectedVideo.template && selectedVideo.template.isPremium ? "myvideo.pay.dialog.text2" : "myvideo.pay.dialog"} components={{ br: <br /> }} />} open={isOpenPayTwoButton} onClose={this.handleClosePayDialog} onClick={this.handleClickPay} confirmBtnLabel={i18n.t("myvideo.pay.dialog.button")} isFlexConfirmBtn>
          <div>{i18n.t("myvideo.pay.dialog.text")}</div>
        </TwoBtnDialog>
        <TwoBtnDialog header={<Trans i18nKey="myvideo.use.coupon.dialog" components={{ br: <br /> }} />} open={isOpenUseCouponTwoButton} onClose={this.handleCloseUseCouponDialog} onClick={() => this.handleClickUseCoupon(selectedVideo && selectedVideo, true)}>
          <div>{i18n.t("myvideo.use.coupon.dialog.text")}</div>
        </TwoBtnDialog>
        <Uploading open={this.state.isUploading} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  paymentMode: state.paymentModeStore.paymentMode,
  pointTicket: state.pointTicketStore.pointTicket,
  accountStatus: state.accountStatusStore.accountStatus,
  uploadImgBloburl: state.uploadImgBloburlStore.uploadImgBloburl,
  coupons: state.couponStore.coupons
})

export default connect(mapStateToProps, null)(TemplatePage)